module.exports = __webpack_public_path__ + "static/media/logo-khcnqb.e0086709.jpeg";